import { render, staticRenderFns } from "./SemesterDetail.vue?vue&type=template&id=3a6464ab&scoped=true"
import script from "./SemesterDetail.vue?vue&type=script&lang=js"
export * from "./SemesterDetail.vue?vue&type=script&lang=js"
import style0 from "./SemesterDetail.vue?vue&type=style&index=0&id=3a6464ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6464ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VDataTable,VForm,VIcon,VTextField})
